import React from "react";
interface InputProps {
  id: string;
  name: string;
  type: string;
  value: string | number;
  onChange: any;
  placeholder: string;
  className: string;
  required: boolean;
}

const Input: React.FC<InputProps> = ({
  id,
  name,
  type,
  value,
  onChange,
  placeholder,
  className,
  required,
}) => {
  return (
    <div className="w-full sm:w-full mb-4">
      <input
        type={type}
        id={id}
        name={name}
        className={className}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoComplete="off"
      />
    </div>
  );
};
export default Input;
